<script lang="ts" setup>
import { computed } from 'vue'

import cn from 'internal/tailwind-classmerge'

import {
  type DialogContentEmits,
  type DialogContentProps,
  DrawerContent,
  useForwardPropsEmits,
} from '@fond-of/fondof-ui'

const props = defineProps<DialogContentProps>()
const emits = defineEmits<DialogContentEmits>()

const delegatedProps = computed(() => {
  const { to: _, ...delegatedProps } = props
  return delegatedProps
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <DrawerContent
    v-bind="forwarded"
    :class="
      cn(
        'fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col bg-white px-4 pb-6 pt-4 shadow-md shadow-black',
        props.class
      )
    "
    :to="props.to"
  >
    <template #overlay>
      <slot name="overlay" />
    </template>
    <template #lever>
      <slot name="lever" />
    </template>
    <slot />
  </DrawerContent>
</template>
